export const langs = ['ru', 'en', 'sr']